import './styles.scss'
import ToolTip from '../ToolTip'
import PropTypes from 'prop-types'

const Icon = (props) => {
  let icon
  if (props.type === 'fa') {
    icon = <i className={props.type + ' ' + props.faClassName}/>
  } else if (props.type === 'im') {
    icon = <i className={props.type + ' ' + props.imClassName}/>
  } else {
    icon = <span/>
  }

  const classNames = 'Icon Icon-' + props.size
    + ' Icon-' + props.type
    + ' Icon-BG-' + props.background
    + ' ToolTip-Handle clearfix'
    + (props.extraClassNames ? ' ' + props.extraClassNames : '')

  return (
    <span
      className={classNames}
      onClick={props.onClick}>
        {props.tooltip &&
          <ToolTip>{props.tooltip}</ToolTip>
        } {icon}
      </span>
  )
}

Icon.defaultProps = {
  size: 'small',
}

Icon.propTypes = {
  size: PropTypes.string,
  type: PropTypes.string.isRequired,
  background: PropTypes.string,
  tooltip: PropTypes.any,
  faClassName: PropTypes.string,
  imClassName: PropTypes.string,
  extraClassNames: PropTypes.string,
}

export default Icon
